export default __webpack_public_path__ + "static/media/2_0114.8fc0026d.webp";